import React from 'react';
import { cn } from '../../utils/lib/utils';

export function Stack({ className, space = 4, ...props }) {
  const spaceClasses = {
    1: 'space-y-1',
    2: 'space-y-2',
    3: 'space-y-3',
    4: 'space-y-4',
    5: 'space-y-5',
    6: 'space-y-6',
    8: 'space-y-8',
    10: 'space-y-10',
    12: 'space-y-12',
  };

  return (
    <div
      className={cn(
        'flex flex-col',
        spaceClasses[space] || `space-y-${space}`,
        className
      )}
      {...props}
    />
  );
} 